/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './conversation.mobile.less';

import ImgConversationLeft from '../../../../../assets/conversation-left.png';
import ImgConversationRight from '../../../../../assets/conversation-right.png';

interface IConversationProps {
  message1: string | React.ReactNode;
  message2: string | React.ReactNode;
  avater1?: string;
  avater2?: string;
  className?: string;
  style?: any;
}

const Conversation: React.FunctionComponent<IConversationProps> = ({
  avater1,
  avater2,
  message1,
  message2,
  className,
  style,
}) => {
  const [conversation, setConversation] = React.useState(0);
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  React.useEffect(() => {
    if (playFlag) {
      setConversation(0);
      setTimeout(() => {
        setConversation(1);
      }, 500);
      setTimeout(() => {
        setConversation(2);
      }, 1500);
    }
  }, [playFlag]);
  const getImg = (img: string) =>
    require(`./../../../../../assets/${img}`).default;
  return (
    <div
      ref={crrRef}
      style={style}
      className={`conversation component ${className}`}
    >
      <div className="conversation-line1">
        {avater1 && <img className="avater" src={getImg(avater1)} alt="" />}
        <div
          className={`conversation-message animation ${
            conversation >= 1 ? 'fade-in' : ''
          }`}
        >
          <img
            className="conversation-message-bg"
            src={ImgConversationLeft}
            alt=""
          />
          {typeof message1 === 'string' ? (
            <div
              className="conversation-message-text"
              dangerouslySetInnerHTML={{ __html: message1 }}
            />
          ) : (
            <div className="conversation-message-text">{message1}</div>
          )}
        </div>
      </div>
      <div className="conversation-line2">
        {avater2 && <img className="avater" src={getImg(avater2)} alt="" />}
        <div
          className={`conversation-message animation ${
            conversation >= 2 ? 'fade-in' : ''
          }`}
        >
          <img
            className="conversation-message-bg"
            src={ImgConversationRight}
            alt=""
          />
          {typeof message2 === 'string' ? (
            <div
              className="conversation-message-text"
              dangerouslySetInnerHTML={{ __html: message2 }}
            />
          ) : (
            <div className="conversation-message-text">{message2}</div>
          )}
        </div>
      </div>
    </div>
  );
};

Conversation.defaultProps = {
  className: '',
  style: {},
  avater1: require(`../../../../../assets/avater6.png`).default,
  avater2: require(`../../../../../assets/avater7.png`).default,
};

export default Conversation;
